import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { LogReferenceTypeEnum } from '../enum/LogReferenceTypeEnum';
import { ILogMinify } from '../interface/log/ILogMinify';
import { ILog } from '../interface/log/ILog';

export default class LogService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/log");
  }

  public getBasic = async (referenceType: LogReferenceTypeEnum, referenceId: number): Promise<ILogMinify[]> => await this.GET(`/${referenceType}/${referenceId}`);
  public getDetail = async (logId: number): Promise<ILog> => await this.GET(`/${logId}`);
}
